import { render } from "./ShowMobile.vue?vue&type=template&id=997a0ea2&lang=pug"
import script from "./ShowMobile.vue?vue&type=script&lang=ts"
export * from "./ShowMobile.vue?vue&type=script&lang=ts"
script.render = render

export default script